/* eslint-disable */
import { bus } from '../../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
export default {
  name: 'create-quiz-reward',
  components: {},
  props: [],
  data () {
    return {
      name:'',
      amount:'',
      amount_text:'',
      currency:'',
      index:'',
      is_jackpot:false,
      submitted:false
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    jackpotStatusFun(){
      if(this.is_jackpot == true){
        this.is_jackpot = false
      }else{
        this.is_jackpot = true
      }
    },
    createRewardsSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            quiz:this.$route.params.quizId,
            name: this.name,
            amount: this.amount,
            amount_text: this.amount_text,
            currency:this.currency,
            index:this.index,
            is_jackpot:this.is_jackpot,
          }
          this.$store.dispatch('createQuizRewardPointsFun', data)
          .then((res) => {
            this.name = '',
            this.amount = '',
            this.amount_text = '',
            this.currency = '',
            this.index = '',
            this.is_jackpot = false,
            toast.success(res.data.msg);
            this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
  }
}


